/* src/app/order/modals/order-price-list-custom-item-modal/order-price-list-custom-item-modal.component.scss */
/*# sourceMappingURL=order-price-list-custom-item-modal.component.css.map */
